var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    AddVariablesBrickModel: function (opts) {
        Operator.Layout.setupCollections(opts.editor.find('form'));
    }
});